module.exports = __webpack_public_path__ + "static/lemonfloralhamper-59f4043dc095d891efc17e520e590667.jpeg";